/* @flow */
import { connect } from 'react-redux'

import ProjectLinks from './ProjectLinksCore'

export default connect()(ProjectLinks)
